

export const roles = {
  CLEARING_LIGHT: 'CLEARING_LIGHT',
  CLEARING_OPERATOR: 'CLEARING_OPERATOR',
  CLEARING_VIEWER: 'CLEARING_VIEWER',
  CLEARING_ADMINISTRATOR: 'CLEARING_ADMINISTRATOR',
  CLEARING_SUPER_ADMINISTRATOR: 'CLEARING_SUPER_ADMINISTRATOR',
}
